define('models/pages/basket/basket',[
    'underscore',
    'chaplin',
    'models/base/model',
    'models/base/collection',

    'models/pages/basket/basket-item-collection',

    'config/application',

    'lib/utils'
], function(
    _, Chaplin, Model, Collection,
    BasketItemCollection,
    appCfg,
    utils
) {
    'use strict';

    var BasketModel = Model.extend({
        urlPath: '/pages/basket/items',
        defaults: {
            expanded: false,
            canBuy: false
        },
        timerInterval: 1000,
        constructor: function() {
            Model.apply(this, arguments);

            this.items = new BasketItemCollection();
            this.on('beforeLoad', function() {
                this.items.beginSync();
            });

            this.on('afterLoad', function() {
                this.items.finishSync();
            });

            this.on('change:canBuy', function(a, value) {
                this.items.each(function(model) {
                    model.set('canBuy', value);
                });
            });

            this.items.on('change:amount reset remove add', _.bind(this.updateSum, this));

            this.canBuy();
        },
        updateSum: function() {
            var _this = this;
            var value = this.items.reduce(function(value, model) {
                return value + model.get('traderViewPrice') * model.get('amount');
            }, 0);
            if (value === 0) {
                setTimeout(function () {
                    _this.destroy();
                }, 100);
            } else {
                this.set('value', value);
            }
        },
        dispose: function() {
            if (this.disposed) { return; }

            if (this.timeout) { clearTimeout(this.timeout); }

            this.items.dispose();

            Model.prototype.dispose.apply(this, arguments);
        },
        buy: function(next) {
            var _this = this;
            utils.ajax(utils.getApiUrl('/basket/' + this.get('tradeId'), null, true), 'POST').complete(function(xhr) {
                var result = xhr.responseJSON || {};
                var resultMap = {
                    'error': 'Неизвестная ошибка.',
                    'limit': 'Для оформления заказа находящегося в вашей корзине недостаточно денежных средств.<br>По вопросу получения кредита, обратитесь к вашему персональному менеджеру.',
                    'closed': 'Торговая сессия по Т.П. ' + _this.get('tradeCode') + ' закрыта, по вопросам оформления заказа обратитесь к своему персональному менеджеру.'
                };
                if (result.status === 'success' || result.status === 'partial') {
                    next(null);
                } else {
                    next(resultMap[result.status || 'error'] || resultMap.error);
                }
            });
        },
        parse: function(data) {
            var tradeId = this.get('tradeId');
            _.each(data.items, function(item){
                item.tradeId = tradeId;
            });

            this.items.reset(data.items);
            this.canBuy();
            this.timerStart();
            return data;
        },
        urlParams: function() {
            var params = Model.prototype.urlParams.apply(this, arguments);
            params.tradeId = this.get('tradeId');
            return params;
        },
        canBuy: function() {
            var et, ct, canBuy;

            var endTime =this.get('endTime');
            var endTimeOnline = this.get('endTimeOnline');

            ct = (new Date()).getTime();
            canBuy = false;

            if (endTime) {
                et = (new Date(endTime)).getTime();
                canBuy = (ct <= et);
            }

            if (endTimeOnline) {
                et = (new Date(endTimeOnline)).getTime();
                canBuy = canBuy || (ct <= et);
            }

            canBuy = canBuy || (appCfg.environment === 'development');

            this.set('canBuy', canBuy);

            this.items.each(function(model) {
                model.set('canBuy', canBuy);
            });

            return canBuy;
        },
        timerStart: function() {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            if (!this.timerEnabled) { return; }

            var _this = this;

            this.timeout = setTimeout(function() {
                _this.timeout = null;

                if (!_this.timerEnabled) { return; }

                _this.canBuy();
                _this.timerStart();

            }, this.timerInterval);
        }
    });

    return BasketModel;
});
